import { getTierIds } from '../../../../utils/getTierIds'
import { FREE_TIER_ID } from '../../consts'
import type { FormValues } from '../types'

export const getCommonPerkPayload = (formValues: FormValues) => {
  const { title, description, selectedTiers } = formValues

  const tiers = getTierIds(selectedTiers).filter((tier) => tier.id !== FREE_TIER_ID)

  return {
    title,
    description,
    tiers,
  }
}
